module.exports = __webpack_public_path__ + "img/img_tex-gala.ebb96168.jpg";